// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__h8V5I","content":"Consent_content__1snz4","footer":"Consent_footer__beOh8"};